
export default function mergeClassNames(...args: (string | boolean | undefined)[]): string {
  return [...args].filter((x) => x).join(' ');
}

